import { gql } from '@apollo/client';

export const GET_CREDENTIALS = gql`
  query credentials($args: CredentialsInput!) {
    credentials(args: $args) {
      pageInfo {
        hasPreviousPage
        hasNextPage
        startCursor
        endCursor
        totalCount
      }
      edges {
        cursor
        node {
          correlations {
            assetName
            assetId
          }
          userName
          passwordHash
          hashType
          cracked
          userInfo
          homeDir
          shell
          filePath
        }
      }
    }
  }
`;
